import React from 'react';
import PropTypes from 'prop-types';

import GenericDetails from 'partial/components/GenericDetails';

import {
  REPRESENTATIVE_INFORMATION_FORMAT,
  HOME_ADDRESS_FORMAT,
  BANK_DETAILS_FORMAT,
  BUSINESS_INFO_FORMAT,
  BUSINESS_TYPE_LABEL,
  BUSINESS_TYPE_IMAGE,
  UPLOADED_ID_FORMAT,
  GOVERNMENT_INFO_FORMAT,
} from '../constants';

function MerchantBusinessInfo({ type, data, isLoading }) {
  return (
    <>
      <div className="title-h1 mb-3">Business Information</div>
      <div className="data-container py-4 border-t-4 border-b-4 border-gray-100">
        <div className="flex items-center space-x-2">
          <img src={BUSINESS_TYPE_IMAGE[type]} alt="" />
          <div className="flex flex-col">
            <span className="font-title block text-sm font-medium text-gray-500">
              Type of Business
            </span>
            <div className="title-h2 capitalize">
              {BUSINESS_TYPE_LABEL[type]}
            </div>
          </div>
        </div>
      </div>
      <div className="data-container py-4 border-b-4 border-gray-100">
        <div className="title-h2 mb-5">
          {type === 'CORPORATION' || type === 'GOVERNMENT'
            ? "Representative's Information"
            : "Owner's Information"}
        </div>
        <GenericDetails
          data={data || {}}
          isLoading={isLoading}
          format={REPRESENTATIVE_INFORMATION_FORMAT(type)}
          numberOfCols={2}
        />
      </div>
      <div className="data-container py-4 border-b-4 border-gray-100">
        <div className="title-h2 mb-5">Home Address</div>
        <GenericDetails
          data={data || {}}
          isLoading={isLoading}
          format={HOME_ADDRESS_FORMAT}
          numberOfCols={1}
        />
      </div>
      <div className="data-container py-4 border-b-4 border-gray-100">
        <div className="title-h2 mb-5">Uploaded ID/s</div>
        <GenericDetails
          data={data || {}}
          isLoading={isLoading}
          format={UPLOADED_ID_FORMAT}
          numberOfCols={1}
        />
      </div>
      {type === 'GOVERNMENT' && (
        <div className="data-container py-4 border-b-4 border-gray-100">
          <div className="title-h2 mb-5">Government Details</div>
          <GenericDetails
            data={data || {}}
            isLoading={isLoading}
            format={GOVERNMENT_INFO_FORMAT}
            numberOfCols={3}
          />
        </div>
      )}

      <div className="data-container py-4 border-b-4 border-gray-100">
        <div className="title-h2 mb-5">Business Information</div>
        <GenericDetails
          data={data || {}}
          isLoading={isLoading}
          format={BUSINESS_INFO_FORMAT[type]}
          numberOfCols={3}
        />
      </div>
      <div className="data-container py-4">
        <div className="title-h2 mb-5">Bank Details</div>
        <GenericDetails
          data={data || {}}
          isLoading={isLoading}
          format={BANK_DETAILS_FORMAT}
          numberOfCols={3}
        />
      </div>
    </>
  );
}

MerchantBusinessInfo.propTypes = {
  type: PropTypes.string,
  data: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool,
};

MerchantBusinessInfo.defaultProps = {
  type: '',
  isLoading: false,
};

export default MerchantBusinessInfo;
